import EODPerformanceReport from "./EODPerformanceReport";

export default function DataAnalysisContainer() {
    return (
        <EODPerformanceReport  />
    );
}
